// extracted by mini-css-extract-plugin
var _1 = "ybF9B";
var _2 = "qPXh6";
export { _1 as "base", _2 as "empty" }
